import { ActionIcon, CopyButton, Tooltip, Flex, Text, } from '@mantine/core';
import { IconCopy, IconCheck } from '@tabler/icons-react';

import type { FloatingPosition, FloatingAxesOffsets, MantineSize } from '@mantine/core';

const renderCopyActionIcon = (copied: boolean, iconSize: string | number) => (
  <ActionIcon color={copied ? 'teal' : 'blue'} variant="subtle">
    {copied ? <IconCheck size={iconSize} /> : <IconCopy size={iconSize} />}
  </ActionIcon>
);

type Props = {
  text: string;
  textSize?: MantineSize | (string & {});
  showText?: boolean;
  leftIcon?: boolean;
  rightIcon?: boolean;
  iconSize?: number | string;
  tooltipPosition?: FloatingPosition;
  tooltipOffset?: number | FloatingAxesOffsets;
};

export const CustomCopyBtn = (props: Props) => {
  const {
    text,
    textSize = "xs",
    showText = true,
    leftIcon,
    rightIcon,
    iconSize = 16,
    tooltipPosition = "right",
    tooltipOffset = 0,
  } = props;

  return (
    <span onClick={(e) => e.stopPropagation()}>
      <CopyButton value={text} timeout={2000}>
        {({ copied, copy }) => (
          <Tooltip
            label={copied ? 'Скопировано' : 'Копировать'}
            withArrow
            position={tooltipPosition}
            offset={tooltipOffset}
          >
            <Flex gap="0px" wrap="nowrap" align="center" justify="flex-start" onClick={copy}>
              {leftIcon && renderCopyActionIcon(copied, iconSize)}

              {showText && (
                <Text
                  size={textSize}
                  inherit
                  style={{
                    cursor: 'pointer',
                    wordBreak: 'break-all',
                  }}>
                  {text}
                </Text>
              )}

              {rightIcon && renderCopyActionIcon(copied, iconSize)}
            </Flex>
          </Tooltip>
        )}
      </CopyButton>
    </span>
  );
}
